import * as React from "react";
import QuestionLabel from "./QuestionLabel";
import QuestionError from "./QuestionError";
import * as $ from "jquery";
import { SurveyQuestion } from "../../../types";

interface CheckBoxQuestionProps {
  question: SurveyQuestion;
  onChange: (question: any, values: any) => void;
  error: string;
}

class CheckBoxQuestion extends React.Component<CheckBoxQuestionProps, {}> {
  isSingleCheckbox(e: React.FormEvent<HTMLInputElement>) {
    const nodeOrNodes = e.currentTarget.form[e.currentTarget.name];
    return !nodeOrNodes.length;
  }

  handleMultipleCheckboxes(e: React.FormEvent<HTMLInputElement>) {
    const values: Array<any> = [];

    // Use $.each to iterate over the checkboxes. IE doesn't
    // support e.target.form[e.target.name].forEach().
    $.each(e.currentTarget.form[e.currentTarget.name], (index, el) => {
      if (!el.checked) {
        return;
      }

      values.push(el.value);
    });

    this.props.onChange(this.props.question, values.join(", "));
  }

  handleSingleCheckbox(e: React.FormEvent<HTMLInputElement>) {
    const el = e.currentTarget.form[e.currentTarget.name];

    if (el.checked) {
      this.props.onChange(this.props.question, el.value);
    } else {
      this.props.onChange(this.props.question, "");
    }
  }

  onChange = (e: React.FormEvent<HTMLInputElement>) => {
    if (e.currentTarget.checked) {
      e.currentTarget.setAttribute("aria-checked", "true");
    } else {
      e.currentTarget.setAttribute("aria-checked", "false");
    }

    if (this.isSingleCheckbox(e)) {
      this.handleSingleCheckbox(e);
    } else {
      this.handleMultipleCheckboxes(e);
    }
  };

  render() {
    const nameAttr = "velaro-answer-" + this.props.question.QuestionID;

    return (
      <div role="group" aria-label={this.props.question.QuestionText}>
        <QuestionLabel question={this.props.question} />
        {this.props.question.SurveyQuestionChoices.map((choice: any) => {
          const inputId = `velaro-choice-${choice.ChoiceID}`;
          return (
            <div className="checkbox" key={choice.ChoiceID}>
              <input
                type="checkbox"
                id={inputId}
                name={nameAttr}
                value={choice.ChoiceText}
                onChange={this.onChange}
                aria-checked="false"
              />
              <label htmlFor={inputId}>{choice.ChoiceText}</label>
            </div>
          );
        })}
        <QuestionError
          questionId={this.props.question.QuestionID}
          error={this.props.error}
        />
      </div>
    );
  }
}

export default CheckBoxQuestion;
